import React, { Fragment } from 'react'
import { withRouter } from 'react-router'
import Component from 'components/component'
import { Modal } from 'components/modal'
import Spoiler from 'components/spoiler'
import { DI } from 'modules'
import TargetFacebookForm from './target-facebook-form'
import TargetForm from './target-form'
import TargetItem from './target-item'
import { REGEX_LIVE_VIDEO_SLUG } from 'pages/content/lives/view'
import withAnalytic from 'hoc/analytic'

class TargetModal extends Component {
  static defaultProps = {
    custom: false,
  }

  state = {
    openForm: false,
    isLoading: false,
  }

  afterDestroy = () => {
    if (this.props.id === 'hls_dvr') {
      this.setState(prev => ({
        ...prev,
        isLoading: false,
      }))
    }
  }

  toggleHLSLink = () => {
    console.log(this.props.actions.targets)
    this.props.actions.targets
      .getHLSLinks(this.props.liveEvent.slug, this.props.selectedLanguageID)
      .then(resp => {
        this.props.actions.targets.createTarget(this.props.liveEvent.slug, {
          key: resp.body.value,
          language_id: this.props.selectedLanguageID,
          target_type: 'hls_dvr',
        })
      })
  }

  toggleForm = ev => {
    ev && ev.preventDefault()

    this.props.trackClick(
      {
        id: this.props.liveEvent.slug,
        title: this.props.liveEvent.title,
        live_language_id: this.props.selectedLanguageID,
        live_target_type: this.props.targetParams.target_type,
      },
      'book_live_addStream_start'
    )

    if (this.props.id === 'hls_dvr') {
      this.setState(prev => ({
        ...prev,
        isLoading: true,
      }))
      this.toggleHLSLink()
    } else {
      this.setState((state, props) => ({
        openForm: !state.openForm,
      }))
    }
  }

  toggleFacebookForm = ev => {
    ev && ev.preventDefault()
    this.setState((state, props) => ({
      openFacebookForm: !state.openFacebookForm,
    }))
  }

  render() {
    const [id] = this.props.match.params.id.match(REGEX_LIVE_VIDEO_SLUG)

    const targets =
      this.props.targets.list.getValue(id ? id : '').payload[
        this.props.selectedLanguageID
      ] || []
    const targetParams = Object.entries(this.props.targetParams)

    const filteredTargets = targets.filter(item => {
      return targetParams.every(([key, value]) => item[key] === value)
    })

    const targetsLeft = Math.max(0, 3 - targets.length)
    const strings = this.props.common.strings
    const targetName = this.props.spoilerTitle

    return (
      <Spoiler
        title={targetName}
        defaultOpen={this.props.defaultOpen}
        className="live-target"
        headClassName="live-target__head"
        bodyClassName="live-target-body"
        onChange={this.props.onChange}
      >
        {!!filteredTargets.length && (
          <div className="live-target-list">
            {filteredTargets.map(target => (
              <TargetItem
                key={target.id}
                slug={this.props.liveEvent.slug}
                data={target}
                afterDestroy={this.afterDestroy}
              />
            ))}
          </div>
        )}

        {!!targetsLeft && this.props.id !== 'hls_dvr' && (
          <div className="live-target-buttons">
            <div className="live-target-add">
              <button
                type="button"
                className="btn-bord"
                onClick={this.toggleForm}
              >
                {strings['page.lives.view.add_stream.title']}
              </button>
            </div>
            {/* this.props.id === 'fb' && (
              <Fragment>
                <div className="live-target-or">or</div>
                <div
                  className="live-target-facebook"
                  style={{ flexShrink: '0' }}
                >
                  <button
                    type="button"
                    className="live-target__facebook"
                    onClick={this.toggleFacebookForm}
                    disabled={!this.props.common.cookiesAccepted.marketing}
                  >
                    {strings['page.lives.view.add_stream.login_facebook']}
                  </button>
                </div>
                {!this.props.common.cookiesAccepted && (
                  <div
                    className="live-target-or"
                    style={{
                      whiteSpace: 'break-spaces',
                      opacity: 0.4
                    }}
                  >
                    please accept cookies to use this option
                  </div>
                )}
              </Fragment>
                  )*/}
          </div>
        )}

        {this.props.id === 'hls_dvr' && !filteredTargets.length && (
          <div className="live-target-buttons">
            <div className="live-target-add">
              <button
                type="button"
                className="btn-bord"
                onClick={this.toggleForm}
                disabled={this.state.isLoading}
              >
                {strings['page.lives.view.add_stream.hls.open_link']}
              </button>
            </div>
          </div>
        )}
        <span className="live-target__info">
          {strings['page.lives.view.add_stream.limit_rule']} {targetsLeft}{' '}
          {this.props.network}{' '}
          {strings['page.lives.view.add_stream.limit_rule_pages']}.
        </span>
        {this.state.openForm && (
          <Modal onClose={this.toggleForm}>
            <TargetForm
              id={this.props.id}
              targetName={this.props.targetName}
              liveEvent={this.props.liveEvent}
              selectedLanguageID={this.props.selectedLanguageID}
              close={this.toggleForm}
              streamHelp={this.props.streamHelp}
              custom={this.props.custom}
              targetParams={targetParams}
              targetType={this.props.targetParams.target_type}
            >
              {this.props.instructions}
            </TargetForm>
          </Modal>
        )}
        {this.state.openFacebookForm && (
          <Modal onClose={this.toggleFacebookForm}>
            <TargetFacebookForm
              liveEvent={this.props.liveEvent}
              selectedLanguageID={this.props.selectedLanguageID}
              targetParams={targetParams}
              close={this.toggleFacebookForm}
            />
          </Modal>
        )}
      </Spoiler>
    )
  }
}
export default withRouter(
  DI(['targets'])(
    withAnalytic(TargetModal, {
      groupEvent: 'ACTION_LIVE',
      trackData: {
        location: {
          page_layout: 'live_page',
          list: 'none',
        },
      },
    })
  )
)
